import React, { useEffect } from "react"
import * as S from "./custom-checkbox-group.styles"
import { Controller, useFormContext } from "react-hook-form"
import { Checkbox, FormControlLabel, FormGroup } from "@mui/material"

const CustomCheckboxGroup = ({ items, title, name }) => {
  const methods = useFormContext()
  const { control, watch, getValues, setValue } = methods

  const handleOnChange = (event, checked, field) => {
    let auxValues = field.value ?? []

    if (checked) {
      field.onChange([...auxValues, event.target.value])
    } else {
      field.onChange(field.value.filter(value => value !== event.target.value))
    }
  }

  return (
    <S.Wrapper>
      {title && <S.Title>{title}</S.Title>}
      <Controller
        control={control}
        name={name}
        render={({ field }) => (
          <S.CustomFormGroup>
            {items?.map(({ value, label }, index) => (
              <S.CustomFormControlLabel
                key={`${index}-${value}`}
                control={
                  <Checkbox
                    value={value}
                    checked={field?.value?.some(auxValue => auxValue === value)}
                    onChange={(event, checked) =>
                      handleOnChange(event, checked, field)
                    }
                  />
                }
                label={label}
              />
            ))}
          </S.CustomFormGroup>
        )}
      />
    </S.Wrapper>
  )
}

export default CustomCheckboxGroup
